export default function serializeObject(form) {
    // Setup our serialized data
    var serialized = {};

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (
            !field.name ||
            field.disabled ||
            field.type === 'file' ||
            field.type === 'reset' ||
            field.type === 'submit' ||
            field.type === 'button'
        )
            continue;

        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized[field.name] = field.options[n].value;
            }
        } else if (field.type === 'checkbox') {
            if (field.checked) {
                const name = field.name.replace(/\[\]/, '');

                if (!serialized[name]) serialized[name] = [];
                serialized[name].push(field.value);
            }
        } else if (field.type === 'radio') {
            if (field.checked) {
                const name = field.name.replace(/\[\]/, '');
                serialized[name] = field.value;
            }
        } else {
            serialized[field.name] = field.value;
        }
    }

    return serialized;
}
